import {
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  HostListener,
  AfterViewChecked,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormArray,
  Validators,
} from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router, Data, NavigationStart } from "@angular/router";
import { DownloadDialogComponent } from "@dialogs/download/download.component";
import { DownloadService } from "@services/download.service";
import { CommonService } from "@services/common.service";
import { CanvasService } from "@services/canvas.service";
import { DirtyComponent } from "../../models/dirty-component";
import { Subscription, from, of } from "rxjs";
import { mergeMap, catchError } from "rxjs/operators";
import { ConfirmationDialogComponent } from "@dialogs/confirmation/confirmation.component";
import { DetailDialogComponent } from "@dialogs/detail/detail.component";
import { CreateDialogComponent } from "@dialogs/create/create.component";
import { SecurityAccessDialogComponent } from "@dialogs/security-access/security.component";
import { AccessDialogComponent } from "@dialogs/access/access.component";

export interface canvasOptions {
  sortOptions: any;
  groupOptions: any;
  quantifierOptions: any;
  formatterOptions: any;
}
export interface ExportBody {
  id: any;
  title: any;
  type: any;
}
@Component({
    selector: "app-builder-page",
    templateUrl: "./builder.component.html",
    styleUrls: ["./builder.component.scss"],
    standalone: false
})
export class BuilderPageComponent
  implements
    OnInit,
    OnDestroy,
    DirtyComponent,
    OnChanges,
    OnDestroy,
    AfterViewChecked
{
  private listener: any;
  private exportListener: any;

  private saveAndExportListener: any;
  private deleteListener: any;
  private duplicateListener: any;
  private viewListener: any;
  private editListener: any;
  private detailListener: any;
  private populateListener: any;
  private dirtyListener: any;
  private exportToDashboardListener: any;
  private editAsReportListener: any;
  private editAsLayoutListener: any;
  private groupListener: any;
  private viewGroupListener: any;
  private disableListener: any;
  private progressiveLoadSub: any;
  private isProgressivelyLoading = false;
  private progressiveLoadTypes = ["dashboard", "report"];

  public canvasType = "report";
  public canvasMode = "edit";
  public canvasLayout: boolean = false;
  public hasEdit: boolean = false;

  public page = "report";
  public status = "draft";
  public module_id: any;

  public editable: boolean = false;
  public isVisible: boolean = false;
  public canvasAccess: boolean = true;

  public disableEdit = false;
  public messageDetail: string = '';

  @Input() isPreview?: boolean = false;
  @Input() id?: number;

  relatedDashboards: any[] = [];

  constructor(
    public downloadService: DownloadService,
    private _snackBar: MatSnackBar,
    private fb: FormBuilder,
    public commonService: CommonService,
    private canvasService: CanvasService,
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    private cdRef: ChangeDetectorRef
  ) {
    this._intializeListeners();
  }

  @HostListener("window:unload", ["$event"]) unloadHandler(event: any) {
    this.PostCall();
  }

  @HostListener("window:beforeunload", ["$event"]) beforeUnloadHander(
    event: any
  ) {
    if (!this.isDirty) return true;
    return false;
  }

  public parameterValue: string = "";
  public canvasForm!: FormGroup;
  public canvasData: any = "";
  public moduleColor: string = "black";
  public chartData: any = [];
  public data: any;
  public expanded: boolean = false;
  public chartType: string = "Table";
  public dataFields: any;
  public manualChartColors: any;
  public dynamicChartColors: any;
  public visibleDataPoints: any;
  public appliedSeries: any;
  public workflows: any;
  public dataPointAliases: any;
  public filterFields: any;
  public dataPointFields: any;
  public sortFields: any;
  public groupFields: any;
  public quantifierFields: any;
  public formatdata: any;
  public canvasOptions: canvasOptions = {
    sortOptions: [],
    groupOptions: [],
    quantifierOptions: [],
    formatterOptions: [],
  };

  public style: object = {};
  public isFavorite: boolean = false;
  public selectedItem: any = null;
  public selectedChartType: string = "";
  public selectedChart = -1;

  public isDirty = false;

  public itemId: any;
  private subscr!: Subscription;
  public canAddModifiers: boolean = false;
  public openFirst: boolean = true;
  public calculationOptions: any = [];
  public loading: boolean = true;
  public customLinks: any = [];
  public title: string = "";
  public description: string = "";
  public securityGroups: any = [];
  public userCategories: any = [];

  public featureFlags: any = [];

  PostCall() {
    //console.log("PostCall");
  }

  getUserCategories() {
    this.userCategories = JSON.parse(
      sessionStorage.getItem("userCategoryListing")
    );
  }

  getCanvas(id: number) {
    this.loading = true;
    if (this.progressiveLoadTypes.includes(this.canvasType)) {
      this.canvasService.getCanvasShell(id).subscribe(
        (shell: any) => {
          const errorMessage = shell.data.errorMessage || null;
          if (errorMessage)
            this.commonService.openErrorDialog(
              "canvas",
              errorMessage.text || "",
              errorMessage.detail || ""
            );

          const allItems: any[] = shell.data.canvasItemsIndex?.data || [];
          const nonChartItems: any[] = shell.data.canvasItemsNonChart?.data || [];
          const nonChartMap = new Map(nonChartItems.map((item: any) => [item.id, item]));

          shell.data.canvasItems = {
            data: allItems.map((item: any) => {
              if (item.type !== 'chart') {
                const real = nonChartMap.get(item.id);
                return real
                  ? { ...real, isLoading: false, isError: false }
                  : { id: item.id, canvasItemType: item.type, isVisible: true, isLoading: false, isError: false, object: { data: { id: item.id, type: item.type } } };
              }
              return {
                id: item.id,
                canvasItemType: item.type,
                isVisible: true,
                isLoading: true,
                isError: false,
                object: { data: {} },
              };
            }),
          };

          this.loadData(shell);
          this.loadChartsProgressively(allItems.filter((item: any) => item.type === 'chart'));
        },
        (error: any) => {
          this.isDirty = false;
          if (error.status === 404) this.router.navigate(["/404"]);
          if (error.status === 500) this.router.navigate(["/500"]);
        }
      );
    } else {
      this.canvasService.getCanvas(id).subscribe(
        (success: any) => {
          const errorMessage = success.data.errorMessage || null;
          if (errorMessage)
            this.commonService.openErrorDialog(
              "canvas",
              errorMessage.text || "",
              errorMessage.detail || ""
            );
          this.loadData(success);
        },
        (error: any) => {
          this.isDirty = false;
          if (error.status === 404) this.router.navigate(["/404"]);
          if (error.status === 500) this.router.navigate(["/500"]);
        }
      );
    }
  }

  loadData(data: any): void {
    this.canvasData = data;

    this.canvasService.saveCanvasItems(this.canvasData.data.canvasItems.data);
    if (data.meta.featureFlags) this.featureFlags = data.meta.featureFlags;

    const currentUrl = this.router.url;
    const isEditPage = currentUrl.includes("edit");
    //redirecting to view page if any canvas items are not viewable

    if (isEditPage) {
      if (!data.data.hasEdit) {
        this.refreshUI("view", false);
        this.dialog.open(AccessDialogComponent, {
          panelClass: "modalbox-info",
        });
      } else {
        let stopLoop = false;
        data.data.canvasItems.data.forEach((item: any, index: number) => {
          if (!item.isVisible) {
            this.refreshUI("view", false);
            if (!stopLoop) {
              stopLoop = true;
              this.canvasAccess = false;
              this.dialog.open(AccessDialogComponent, {
                panelClass: "modalbox-info",
              });
            }
          }
        });
      }
    } else {
      data.data.canvasItems.data.forEach((item: any, index: number) => {
        if (!item.isVisible) {
          this.canvasAccess = false;
        }
      });
    }
    this.setIntitalData();
  }

  loadChartsProgressively(chartItems: any[]): void {
    if (!chartItems.length) return;

    this.progressiveLoadSub?.unsubscribe();
    this.isProgressivelyLoading = true;
    this.progressiveLoadSub = from(chartItems)
      .pipe(
        mergeMap(
          (item: any) =>
            this.canvasService.getCanvasItem(String(item.id)).pipe(
              catchError((error: any) => of({
                _error: true,
                _id: item.id,
                _status: error.status,
                _message: error.error?.errors?.[0] ?? 'Failed to load chart'
              }))
            ),
          4
        )
      )
      .subscribe({
        next: (result: any) => {
          const chartId = result._error ? result._id : result.data?.id;
          const index = this.data.findIndex((d: any) => d.id === chartId);
          if (index === -1) return;

          if (result._error) {
            this.data = this.data.map((item: any, i: number) =>
              i === index
                ? { ...item, isLoading: false, isError: true, errorMessage: result._message }
                : item
            );
          } else {
            const chartData = result.data;
            this.data = this.data.map((item: any, i: number) =>
              i === index
                ? { ...item, isLoading: false, isError: false, object: { data: chartData } }
                : item
            );
            this.canvasData.data.canvasItems.data = this.data;
            this.canvasService.saveCanvasItems(this.data);

            if (index === 0 && this.selectedChart === -1) {
              this.isVisible = true;
              this.selectChart(0, this.data[0].object.data);
              this.openFirst = true;
              setTimeout(() => (this.openFirst = false), 100);
            } else if (this.selectedChart === index) {
              this.selectChart(index, this.data[index].object.data);
            }
          }
        },
        complete: () => {
          this.isProgressivelyLoading = false;
        },
      });
  }

  setCanvasData(data: any) {
    // this.editable = data.hasEdit || false;
    this.status = data.status;
  }

  setIntitalData() {
    // add canvas coordinates
    if (this.canvasData["data"].canvasCoordinates) {
      const canvasItems = this.canvasData["data"].canvasItems.data;
      const canvasCoordinates = this.canvasData["data"].canvasCoordinates.data;

      canvasItems.forEach((item: any, index: number) => {
        if (canvasCoordinates[index]) {
          item.cols = canvasCoordinates[index].cols || 4;
          item.rows = canvasCoordinates[index].rows || 1;
          item.x = canvasCoordinates[index].x || 0;
          item.y = canvasCoordinates[index].y || 0;
        }
      });
    }

    this.canvasType = this.canvasData["data"].canvasType;
    this.hasEdit = this.canvasData["data"].hasEdit;

    this.status = this.canvasData["data"].status;
    this.canvasOptions.sortOptions =
      this.canvasData["data"].defaults.data.sorts;
    this.canvasOptions.groupOptions =
      this.canvasData["data"].defaults.data.groups;
    this.canvasOptions.quantifierOptions =
      this.canvasData["data"].defaults.data.quantifiers;
    this.canvasOptions.formatterOptions =
      this.canvasData["data"].defaults.data.formatters;

    const quantifiers = this.canvasData["data"].defaults.data.quantifiers.data;
    let selected = quantifiers.filter(function (type: any) {
      return type.name == "numericQuantifiersOperator";
    });
    const options = selected[0].options.data;
    this.calculationOptions = options;
    this.canvasForm.get("calculationId")!.setValue(selected[0].id);

    this.canvasForm.get("id")!.setValue(this.canvasData["data"].id);
    this.canvasForm.get("title")!.setValue(this.canvasData["data"].name);

    this.canvasForm.get("title")!.setValue(this.canvasData["data"].name);
    let groups: any = [];
    if (this.canvasData["data"].canvasGroups.data) {
      groups = this.canvasData["data"].canvasGroups.data;
    } else {
      groups = this.canvasData["data"].canvasGroups;
    }

    let securityGroups = this.mergeSecurityGroups(groups);

    this.canvasForm.get("securityGroups")!.setValue(securityGroups);

    this.customLinks = this.canvasData["data"].custom_links;
    this.canvasForm
      .get("customLinks")!
      .setValue(this.canvasData["data"].custom_links);

    this.title = this.canvasData["data"].name;
    this.description = this.canvasData["data"].description;

    this.canvasForm
      .get("module_id")!
      .setValue(this.canvasData["data"].category_id);
    this.module_id = this.canvasData["data"].category_id;
    this.canvasForm
      .get("description")!
      .setValue(this.canvasData["data"].description);
    this.data = this.canvasData.data.canvasItems.data;

    let customLinkArray = [];
    const linkArry = this.canvasForm.get("customLinks")!.value as FormArray;
    if (linkArry) {
      for (let i = 0; i < linkArry.length; i++) {
        const element = linkArry.at(i);
        if (element.valid) {
          customLinkArray.push(element.value);
        }
      }
    }
    this.canvasData.data.custom_links = customLinkArray;

    this.canvasData.data.title = this.canvasForm.get("title")!.value;
    this.canvasData.data.description =
      this.canvasForm.get("description")!.value;
    this.canvasData.data.module_id = this.canvasForm.get("module_id")!.value;

    securityGroups = [];
    securityGroups = this.commonService.formatSecurityGroups(
      this.canvasForm.get("securityGroups")!.value,
      false
    );
    let securityGroupsWithName: any[] = [];
    securityGroupsWithName = this.commonService.formatSecurityGroups(
      this.canvasForm.get("securityGroups")!.value,
      true
    );
    this.canvasData.data.canvasGroups = securityGroupsWithName;

    const firstItem = this.canvasData.data.canvasItems.data[0];
    if (firstItem && !firstItem.isLoading && !firstItem.isError) {
      this.isVisible = firstItem.isVisible;
      this.selectChart(0, firstItem.object.data);
      this.openFirst = true;
      setTimeout(() => {
        this.openFirst = false;
      }, 100);
    }
    if (
      this.canvasData.data.canvasItems.data.length > 0 &&
      this.canvasData.data.canvasItems.data[0].canvasItemType == "chart"
    ) {
    }
    this.loading = false;

    setTimeout(() => {
      this.subscr = this.canvasForm.valueChanges.subscribe(() => {
        this.cdRef.markForCheck();
        this.cdRef.detectChanges();
        this.isDirty = false;
      });

      const result = this.router.url.includes("/view/");
      if (result) {
        this.isDirty = false;
      }
    }, 100);
  }

  refreshUI(mode: string, layout: boolean) {
    this.canvasMode = mode;
    this.canvasLayout = layout;
    this.title = this.canvasForm.get("title")?.value;
  }

  saveCanvas(generateAction: boolean, actionBody: any, publish?: boolean) {
    if (this.isProgressivelyLoading) {
      this._openSnackBar(
        "Charts are still loading - please wait for them to finish before saving.",
        false
      );
      return;
    }
    let customLinkArray = [];
    const linkArry = this.canvasForm.get("customLinks")!.value as FormArray;
    if (linkArry) {
      for (let i = 0; i < linkArry.length; i++) {
        const element = linkArry.at(i);
        if (element.valid) {
          customLinkArray.push(element.value);
        }
      }
    }
    this.canvasData.data.custom_links = customLinkArray;
    this.canvasData.data.title = this.canvasForm.get("title")!.value;
    this.canvasData.data.description =
      this.canvasForm.get("description")!.value;
    this.canvasData.data.module_id = this.canvasForm.get("module_id")!.value;
    let securityGroups: any[] = [];
    securityGroups = this.commonService.formatSecurityGroups(
      this.canvasForm.get("securityGroups")!.value,
      false
    );
    let securityGroupsWithName: any[] = [];
    securityGroupsWithName = this.commonService.formatSecurityGroups(
      this.canvasForm.get("securityGroups")!.value,
      true
    );
    this.canvasData.data.canvasGroups = securityGroupsWithName;

    const formBody = {
      name: this.canvasForm.get("title")!.value,
      category_id: this.canvasForm.get("module_id")!.value,
      description: this.canvasForm.get("description")!.value,
      canvasGroups: securityGroups,
      customLinks: customLinkArray,
      canvasItems: [{}],
    };

    this.data.forEach((object: any) => {
      if (object.isLoading || object.isError) return;
      const chart = object.object.data;
      let dataPointIds: any[] = [];
      let dataPointAliases: any[] = [];
      let visibleDataPointIds: any[] = [];
      let appliedSeries: any[] = [];
      if (
        chart.type == "textBox" ||
        chart.type == "header" ||
        chart.type == "footer" ||
        chart.type == "image"
      ) {
        formBody.canvasItems.push({
          type: chart.type,

          canvasItemType: chart.type,
          value: chart.value,
          itemId: chart.id || null,
          cols: object.cols || 4,
          rows: object.rows || 1,
          x: object.x || 0,
          y: object.y || 0,
        });
      } else {
        chart.dataPoints.data.forEach((datapoint: any) => {
          dataPointIds.push(datapoint.id);
        });
        if (chart.dataPointAliases.data) {
          dataPointAliases = chart.dataPointAliases.data;
        } else {
          dataPointAliases = chart.dataPointAliases;
        }
        if (chart.visibleDataPoints) {
          if (chart.visibleDataPoints.data) {
            chart.visibleDataPoints.data.forEach((datapoint: any) => {
              visibleDataPointIds.push(datapoint.id);
            });
          } else {
            chart.visibleDataPoints.forEach((datapoint: any) => {
              visibleDataPointIds.push(datapoint.id);
            });
          }
        }
        let data: any;
        if (chart.appliedSeries) {
          if (chart.appliedSeries.data) {
            chart.appliedSeries.data.forEach((datapoint: any) => {
              data = {
                dataPointId: datapoint.dataPointId,
                breakDownDataPointId: datapoint.breakDownDataPointId,
              };
              appliedSeries.push(data);
            });
          } else {
            chart.appliedSeries.forEach((datapoint: any) => {
              data = {
                dataPointId: datapoint.dataPointId,
                breakDownDataPointId: datapoint.breakDownDataPointId,
              };
              appliedSeries.push(data);
            });
          }
        }

        let referenceLink: any = "";

        if (chart.referenceLink) {
          referenceLink = {
            isActive: chart.referenceLink.data.isActive,
            type: chart.referenceLink.data.type,
            id: chart.referenceLink.data.id,
          };
        }

        let colorType = "manual";
        if (chart.colorType) colorType = chart.colorType;

        let colors = [];
        if (chart.chartColors) colors = chart.chartColors.data;
        if (chart.manualChartColors) {
          colors = chart.manualChartColors.data;

          chart.manualChartColors.data.forEach((color: any) => {
            if (!color.groupDateRange)
              color.groupDateRange = chart.groupDateRange;
          });
        }

        colors.forEach((color: any) => {
          if (color.value) color.value = color.value.toString();
        });

        let dynamicChartColors: any = [];
        if (chart.dynamicChartColors && chart.dynamicChartColors.data) {
          dynamicChartColors = chart.dynamicChartColors.data;
        } else {
          if (chart.dynamicChartColors)
            dynamicChartColors = chart.dynamicChartColors;
        }

        let groups = this._generateModifiers(
          chart.modifications.data.groups.data,
          false
        );

        let groupDateRangeStyles: any;
        if (
          groups &&
          groups[0] &&
          groups[0].dataPointId &&
          dataPointAliases &&
          chart.groupDateRange
        ) {
          let item = this.getDatapointValueById(
            groups[0].dataPointId,
            dataPointAliases
          );
          groupDateRangeStyles = item[0];
        }

        let body = {
          dataPointIds: dataPointIds,
          dataPointAliases: dataPointAliases,
          title: chart.title || this.canvasForm.get("title")!.value,
          cols: object.cols || 4,
          rows: object.rows || 1,
          x: object.x || 0,
          y: object.y || 0,
          referenceLink: referenceLink,
          quantifiers: this._generateModifiers(
            chart.modifications.data.quantifiers.data,
            false
          ),
          filters: this._generateModifiers(
            chart.modifications.data.filters.data,
            true
          ),
          sorts: this._generateModifiers(
            chart.modifications.data.sorts.data,
            false
          ),
          groups: groups,
          formatters: this.commonService.generateFormatters(
            chart.modifications.data.formatters.data,
            chart,
            this.canvasForm.get("title")?.value
          ),
          itemId: chart.id,
          chartType: chart.chartType,
          dataLimit: chart.dataLimit,
          departmentScope: chart.departmentScope,
          employeeScope: chart.employeeScope,
          canvasItemType: "chart",
          visibleDataPointIds: visibleDataPointIds,
          appliedSeries: appliedSeries,
          chartColors: colors,
          manualChartColors: colors,
          colorType: colorType,
          groupDateRange: chart.groupDateRange,
          groupDateRangeStyles: groupDateRangeStyles,
          dynamicChartColors: dynamicChartColors,
        };
        if (
          appliedSeries.length > 0 &&
          chart.chartType !== "Table" &&
          chart.chartType !== "List"
        ) {
          body["visibleDataPointIds"] =
            this.commonService.generateVisualDataPoints(appliedSeries);
        }
        // body = this.canvasService.sanitizePayload(body);
        formBody.canvasItems.push(body);
      }
    });

    formBody.canvasItems.splice(0, 1);

    if (!this.disableEdit) {
      this.canvasService.triggerDisable();
      const type = this.canvasService
        .saveCanvas(this.canvasForm.get("id")!.value, formBody)
        .subscribe(
          (success: any) => {
            this.canvasService.triggerEnable();
            if (publish) {
              this._openSnackBar(
                this.canvasType[0].toUpperCase() +
                  this.canvasType.slice(1) +
                  " saved & published",
                true
              );
            } else {
              this._openSnackBar(
                this.canvasType[0].toUpperCase() +
                  this.canvasType.slice(1) +
                  " saved",
                true
              );
            }

            this.canvasData.data.updated_at = success.data.updated_at;

            success.data.canvasItemsIndex.data.forEach(
              (chart: any, i: number) => {
                const chartID = chart.id;
                if (this.canvasData.data.canvasItems.data[i]) {
                  this.canvasData.data.canvasItems.data[i].id = chartID;
                  this.canvasData.data.canvasItems.data[i].object.data.id =
                    chartID;
                } else {
                  this.data[i].id = chartID;
                  this.data[i].object.data.id = chartID;
                }
              }
            );

            if (
              this.canvasData.data.canvasItems.data.length > 0 &&
              this.canvasData.data.canvasItems.data[this.selectedChart]
                .canvasItemType == "chart"
            ) {
              this._populateCanvasChartData(
                this.canvasData.data.canvasItems.data[this.selectedChart].object
                  .data,
                false
              );
            }

            this.isDirty = false;
            this.subscr.unsubscribe();
            setTimeout(() => {
              this.subscr = this.canvasForm.valueChanges.subscribe(
                () => (this.isDirty = true)
              );

              if (generateAction) {
                if (actionBody.action == "export") {
                  this.downloadService.startExport(
                    this.parameterValue,
                    this.canvasType,
                    actionBody.title,
                    actionBody.type,
                    actionBody.chartID
                  );
                } else {
                  window.open(
                    "/" + this.canvasType + "/view/" + this.parameterValue,
                    "_blank"
                  );
                }
              }
            }, 0);
          },
          (error: any) => {
            this.isDirty = false;

            this._openSnackBar("There was a problem saving your report", false);
          }
        );
    }
  }

  getDatapointValueById(id: any, list: any) {
    if (id) {
      list.filter(function (element: any) {
        return element.id == id;
      });
    }
    return list;
  }

  _generateModifiers(data: any, condition: boolean) {
    let dataArray: any = [];
    let obj = {};
    data.forEach((dataElement: any, index: number) => {
      let dataPoint;
      const modifications: any[] = [];
      if (dataElement.dataPoint) {
        dataElement.fields.data.forEach((element: any) => {
          modifications.push({ id: element.id, value: element.value });
        });
        dataPoint = dataElement.dataPoint.data.id;
      }
      if (condition) {
        let fieldCondition = condition;
        if (dataElement.fields && dataElement.fields.data) {
          fieldCondition = dataElement.fields.data[0].condition;
        }
        obj = {
          condition: fieldCondition,
          dataPointId: dataPoint,
          modifiers: modifications,
        };
      } else {
        obj = {
          dataPointId: dataPoint,
          modifiers: modifications,
        };
      }
      dataArray.push(obj);
    });

    return dataArray;
  }
  
  openDeleteDialog(): void {
    if(this.canvasType == 'report') {
      this.canvasService.getDashboardByReportId(Number(this.parameterValue)).subscribe(
        (success: any) => {

          let enterpriseDash = success.enterprise || {};
          let legacyDash = success.legacy || {};
          
          this.messageDetail = this.commonService.generateDashboardMessage(enterpriseDash, legacyDash);

          this.loadDeleteDialog();
        },
  
        (error: any) => {
          if (error.status === 404) this.router.navigate(["/404"]);
          if (error.status === 500) this.router.navigate(["/500"]);
        }
      );
    } else {
      this.loadDeleteDialog();
    }
  }

  loadDeleteDialog(): void {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      disableClose: true,
      data: {
        message: "Delete this " + this.canvasType + "?",
        messageDetail: this.messageDetail ?? "",
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.deleteListener.unsubscribe();
        this.isDirty = false;
        this.canvasService.deleteCanvas(this.parameterValue, this.canvasType);
        this.dialog.closeAll();
      } else {
        this.deleteListener.unsubscribe();
        this.deleteListener = this.canvasService
          .listenForDelete()
          .subscribe(() => {
            this.openDeleteDialog();
          });
      }
    });
  }

  duplicateCanvas(): void {
    if (this.isDirty && this.hasEdit) this.saveCanvas(false, null);

    this.dialog.open(CreateDialogComponent, {
      width: "350px",
      disableClose: true,
      data: {
        title: "DUPLICATED - " + this.canvasForm.controls["title"].value,
        module_id: this.canvasForm.controls["module_id"].value,
        canvas_id: this.parameterValue,
        description: this.canvasForm.controls["description"].value,
        canvasType: this.canvasType,
      },
      panelClass: "canvas-dialog",
    });
  }

  openExportToDashboardDialog(): void {
    this.exportToDashboardListener.unsubscribe();
    this.exportToDashboardListener = this.canvasService
      .listenForExportToDashboard()
      .subscribe(() => {
        this.openExportToDashboardDialog();
      });

    let showMessage = false;
    if (this.isDirty) {
      showMessage = true;
    }

    const dialogRef = this.dialog.open(CreateDialogComponent, {
      width: "350px",
      data: {
        title: this.canvasForm.get("title")!.value,
        category_id: this.canvasForm.get("module_id")!.value,
        description: this.canvasForm.get("description")!.value,
        canvasType: "dashboard",
        actionButton: "export",
        canvas_id: this.parameterValue,
        showMessage: showMessage,
      },

      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.saveCanvas(false, null);
        this.page = "dashboard";
        // this.refreshUI(true, "dashboard");
      }
    });
  }

  openEditAsReportDialog(): void {
    this.editAsReportListener.unsubscribe();
    this.editAsReportListener = this.canvasService
      .listenForEditAsReport()
      .subscribe(() => {
        this.openEditAsReportDialog();
      });
    this.refreshUI("edit", false);
  }

  openEditAsLayoutDialog(): void {
    this.editAsLayoutListener.unsubscribe();
    this.editAsLayoutListener = this.canvasService
      .listenForEditAsLayout()
      .subscribe(() => {
        this.openEditAsLayoutDialog();
      });
    this.refreshUI("edit", true);
  }

  openEditDialog(): void {
    this.editListener.unsubscribe();
    this.editListener = this.canvasService.listenForEdit().subscribe(() => {
      this.openEditDialog();
    });
    this.refreshUI("edit", false);
  }

  openPreviewDialog(): void {
    this.viewListener.unsubscribe();
    this.viewListener = this.canvasService.listenForView().subscribe(() => {
      this.openPreviewDialog();
    });
    this.refreshUI("view", false);
  }

  openDownloadDialog(): void {
    this.exportListener.unsubscribe();
    this.exportListener = this.canvasService.listenForExport().subscribe(() => {
      this.openDownloadDialog();
    });
    const id = this.canvasForm.get("id")!.value;
    const title = this.canvasForm.get("title")!.value;
    let showMessage = false;
    if (this.isDirty) {
      showMessage = true;
    }
    let containsOnlyTables = true;
    this.data.forEach((object: any) => {
      if (object.isLoading || object.isError) return;
      const chart = object.object.data;
      if (chart.type) containsOnlyTables = false;
      if (
        chart.chartType &&
        chart.chartType != "Table" &&
        chart.chartType &&
        chart.chartType != "List"
      ) {
        containsOnlyTables = false;
      }
    });

    const dialogRef = this.dialog.open(DownloadDialogComponent, {
      width: "350px",
      data: {
        id: id,
        title: title.split(" ").join("_").replace("'", ""),
        fullReport: true,
        containsOnlyTables: containsOnlyTables,
        showMessage: showMessage,
        type: this.canvasType,
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result && result.result) {
        if (result.save) {
          const exportBody = {
            action: "export",
            id: this.parameterValue,
            title: result.title,
            type: result.type,
            chartID: result.chartID,
          };
          this.saveCanvas(true, exportBody);
        } else {
          this.downloadService.startExport(
            this.parameterValue,
            this.canvasType,
            result.title,
            result.type,
            null
          );
        }
      }
    });
  }

  openDetailDialog(): void {
    this.detailListener.unsubscribe();
    this.detailListener = this.canvasService.listenForDetail().subscribe(() => {
      this.openDetailDialog();
    });
    const dialogRef = this.dialog.open(DetailDialogComponent, {
      width: "350px",
      data: {
        name: this.canvasForm.get("title")!.value,
        category_id: this.canvasForm.get("module_id")!.value,
        description: this.canvasForm.get("description")!.value,
        canvasType: this.canvasType,
      },
      panelClass: "canvas-dialog",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.canvasForm.get("module_id")!.setValue(result.module_id);
        this.canvasForm.get("title")!.setValue(result.title);
        this.canvasForm.get("description")!.setValue(result.description);
      }
    });
  }

  openGroupDialog(viewMode: boolean) {
    this.groupListener.unsubscribe();
    this.viewGroupListener.unsubscribe();

    this.viewGroupListener = this.canvasService
      .listenForViewGroups()
      .subscribe(() => {
        this.openGroupDialog(true);
      });

    this.groupListener = this.canvasService.listenForGroups().subscribe(() => {
      this.openGroupDialog(false);
    });

    const groups = JSON.parse(
      JSON.stringify(this.canvasForm.get("securityGroups")!.value)
    );
    const dialogRef = this.dialog.open(SecurityAccessDialogComponent, {
      disableClose: true,
      data: {
        message: "Remove this data point?",
        securityGroups: groups,
        canvasType: this.canvasType,
        actionButton: "apply",
        dataSetListing: [],
        existingDataFields: [],
        fromCreate: false,
        viewMode: viewMode,
      },
      panelClass: ["canvas-dialog"],
      width: "50vw",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        let tempArray = result._data._value;
        tempArray.forEach((element: any) => {
          element.edit = element.edit ? 1 : 0;
          element.view = element.view ? 1 : 0;
        });
        this.canvasForm.get("securityGroups")?.setValue(tempArray);
      }
    });
  }

  containerWidth() {
    if (
      (this.canvasMode == "edit" && this.canvasLayout) ||
      (this.canvasMode == "view" && !this.canvasLayout)
    )
      return "dashboard";
    return "";
  }

  sortFieldsChangeHandler(event?: any) {
    this.sortFields = [];
    if (event && event.length > 0) {
      this._populateCanvasChartData(
        this.canvasData.data.canvasItems.data[this.selectedChart].object.data,
        true
      );
    }
  }

  filterFieldsChangeHandler(event?: any) {
    this.filterFields = [];
    if (event && event.length > 0) {
      this._populateCanvasChartData(
        this.canvasData.data.canvasItems.data[this.selectedChart].object.data,
        true
      );
    }
  }

  expandedChangedHandler(event: any) {
    this.expanded = event;
  }

  chartTypeChangedHandler(event: any) {
    if (event) {
      this.chartType = event;
    }
  }

  chartTypeAddedHandler(event: any) {
    if (event) {
      event.preventDefault();
    }
  }

  chartTextChangedHandler(event: any) {
    if (event) {
      this.data[event.position].object.data.value = event.value;
    }
  }

  selectChartChangedHandler(event: any) {
    if (event.chart) this.isVisible = event.chart.isVisible;
    this.selectChart(event.id, event.chart);

    this.openFirst = true;
    setTimeout(() => {
      this.openFirst = false;
    }, 100);
  }

  chartDataChangedHandler(event: any) {
    if (event && this.data[this.selectedChart].object.data) {
      // part of refreshing the sidebar items after an error
      //this.data[this.selectedChart].object.data = event;
      
      const errorMessage = event.errorMessage || null;
      if (errorMessage)
        this.commonService.openErrorDialog(
          "canvas",
          errorMessage.text || "Unexpected Problem",
          errorMessage.detail || "An unexpected problem occurred"
        );

      let range = event.groupDateRange;
      let selectedLocalChartData = this.data[this.selectedChart].object.data;

      if (!range) range = "M";
      this.canvasForm.get("groupDateRange")!.setValue(range);

      selectedLocalChartData.groupDateRange = range;
      selectedLocalChartData.dataPoints = event.dataPoints;
      selectedLocalChartData.visibleDataPointIds = event.visibleDataPointIds;
      selectedLocalChartData.quantifiers = event.quantifiers;
      selectedLocalChartData.groups = event.groups;
      selectedLocalChartData.sorts = event.sorts;
      selectedLocalChartData.filters = event.dataPoints;
      selectedLocalChartData.formatters = event.formatters;

      selectedLocalChartData.manualChartColors = event.manualChartColors;
      selectedLocalChartData.dynamicChartColors = event.dynamicChartColors;

      selectedLocalChartData.appliedSeries = event.appliedSeries;
      selectedLocalChartData.chartColors = event.chartColors;

      if (event.chartType == "Pie") {
        event.colorType = "manual";
      }
      if (event.colorType == "manual") {
        if (
          event.chartType != "Table" &&
          event.chartType != "List" &&
          event.chartObject.legend
        ) {
          delete event.chartObject.legend.symbolHeight;
          delete event.chartObject.legend.symbolWidth;
        }
      } else {
        if (
          event.chartType != "Table" &&
          event.chartType != "List" &&
          event.chartObject.legend
        ) {
          event.chartObject.legend.symbolHeight = 1;
          event.chartObject.legend.symbolWidth = 1;
        }
      }
      selectedLocalChartData.chartObject = "empty";

      setTimeout(() => {
        selectedLocalChartData.chartObject = event.chartObject;
      }, 0);

      selectedLocalChartData.chartType = event.chartType;
      selectedLocalChartData.visibleDataPoints = event.visibleDataPoints;
      selectedLocalChartData.dataPointAliases = event.dataPointAliases;
      selectedLocalChartData.dataLimit = event.dataLimit;
      selectedLocalChartData.departmentScope = event.departmentScope;
      selectedLocalChartData.employeeScope = event.employeeScope;
      // check the color return object
      if (event.manualChartColors) {
        selectedLocalChartData.manualChartColors = event.manualChartColors;
        this.manualChartColors = event.manualChartColors.data;
      }
      if (event.chartColors) {
        selectedLocalChartData.manualChartColors = event.chartColors;
        this.manualChartColors = event.chartColors.data;
      }
      selectedLocalChartData.dynamicChartColors = event.dynamicChartColors;
      if (event.dynamicChartColors)
        this.dynamicChartColors = event.dynamicChartColors;

      if (event.colorType) selectedLocalChartData.colorType = event.colorType;

      selectedLocalChartData.workflows = event.workflows;
      selectedLocalChartData.referenceLink = event.referenceLink;
      if (event.modifications.data.filters)
        selectedLocalChartData.modifications.data.filters =
          event.modifications.data.filters;
      selectedLocalChartData.modifications.data.sorts =
        event.modifications.data.sorts;
      selectedLocalChartData.modifications.data.groups =
        event.modifications.data.groups;
      selectedLocalChartData.modifications.data.formatters =
        event.modifications.data.formatters;
      selectedLocalChartData.modifications.data.quantifiers =
        event.modifications.data.quantifiers;

      selectedLocalChartData.showSeriesAlert = false;
      if (selectedLocalChartData.visibleDataPoints.data.length >= 15) {
        if (selectedLocalChartData.dataPoints.data.length > 15)
          this.data[this.selectedChart].object.data.showSeriesAlert = true;
      }

      if (
        event.modifications.data.quantifiers &&
        event.modifications.data.quantifiers.data[0]
      ) {
        this.canvasForm
          .get("calculationMethod")!
          .setValue(
            event.modifications.data.quantifiers.data[0].fields.data[0].value
          );
      } else {
        this.canvasForm.get("calculationMethod")!.setValue(null);
      }
    }
    if (this.canvasData.data.canvasItems.data[this.selectedChart])
      this._populateCanvasChartData(
        this.canvasData.data.canvasItems.data[this.selectedChart].object.data,
        true
      );
  }

  selectChart(id: number, chart: any) {
    const dirty = this.isDirty;
    this.canvasForm.get("calculationMethod")!.setValue(null);

    if (!chart) {
      this.data = [];
      this.dataFields = [];
      this.groupFields = [];
      this.sortFields = [];
      this.canAddModifiers = false;
    } else {
      this.selectedChart = id;
      this.canvasService.setSelected(this.selectedChart);
      if (chart.object) {
        this._populateCanvasChartData(chart.object.data, dirty);

        if (
          chart.canvasItemType == "header" ||
          chart.canvasItemType == "footer" ||
          chart.canvasItemType == "textBox" ||
          chart.canvasItemType == "image"
        ) {
          this.chartType = chart.canvasItemType;
        }
      } else {
        this._populateCanvasChartData(chart, dirty);
      }
    }
  }

  openSettingsChangedHandler(event: any) {
    this.openFirst = true;
    setTimeout(() => {
      this.openFirst = false;
    }, 100);
  }

  addChartChangedHandler(event: any) {
    this.canvasService.getCanvasItem(event).subscribe(
      (success: any) => {
        const canvasItem = success.data;
        const obj = { data: canvasItem };
        const chart = {
          canvasItemType: "chart",
          id: canvasItem.id,
          object: obj,
        };
        this.data.unshift(chart);
        this.selectChart(0, chart);
      },
      (error: any) => {}
    );
  }

  getAllSecurityGroups() {
    this.commonService.getAllSecurityGroups().subscribe((data: any) => {
      this.securityGroups = data.data;
    });
  }

  mergeSecurityGroups(groups: any) {
    let tempGroupArray: any[] = [];
    if (groups) {
      groups.forEach((element: any) => {
        // let obj = this.securityGroups.find((o: any) => o.id === element.id);
        const groupData = {
          id: element.id,
          name: element.name,
          edit: element.edit ? true : false,
          view: element.view ? true : false,
        };
        tempGroupArray.push(groupData);
      });
    }
    const A = tempGroupArray;
    const B = this.securityGroups;
    const result = A.concat(
      B.filter((bo: any) => A.every((ao: any) => ao.id != bo.id))
    );
    return result;
  }

  _populateCanvasChartData(CHART: any, dirty: any) {
    this.canvasForm.get("itemId")!.setValue(CHART.id);
    this.itemId = CHART.id;
    this.chartData = CHART;
    this.isFavorite = this.canvasData["data"].isFavorite;

    let chartTitle = CHART.title || this.canvasData["data"].name;
    this.canvasForm.get("chartTitle")!.setValue(chartTitle);
    this.canvasForm.get("chartType")!.setValue(CHART.chartType);
    if (CHART.dataLimit) {
      this.canvasForm.get("dataLimit")!.setValue(CHART.dataLimit);
    } else {
      this.canvasForm.get("dataLimit")!.setValue(null);
    }
    this.canvasForm.get("departmentScope")!.setValue(CHART.departmentScope);
    this.canvasForm.get("employeeScope")!.setValue(CHART.employeeScope);
    let range = CHART.groupDateRange;
    this.canvasForm.get("groupDateRange")!.setValue(range);

    let groupType = "";
    if (
      CHART.modifications &&
      CHART.modifications.data.groups.data &&
      CHART.modifications.data.groups.data.length > 0
    )
      groupType = CHART.modifications.data.groups.data[0].dataPoint.data.type;

    if (groupType == "date") {
      this.canvasForm.get("isDateGroupRange")!.setValue(true);
    } else {
      this.canvasForm.get("isDateGroupRange")!.setValue(false);
      this.canvasForm.get("groupDateRange")!.setValue("");
    }

    //this line throwing a console error in test
    this.selectedChartType = CHART.chartType;

    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
    this.selectedItem = CHART;

    if (CHART.chartType) {
      // POPULATE CHART DATAPOINT FIELDS
      // MERGING WITH QUANTIFIER MODIFIERS
      this.dataFields = this._addQuantifierValues(CHART);
      const datapoints: any[] = [];
      this.dataFields.forEach((field: any) => {
        datapoints.push(field.id);
      });
      this.canvasForm.get("dataPointIds")!.setValue(datapoints);

      if (CHART.chartType != "Table" && CHART.chartType != "List") {
        if (CHART.colorType == "dynamic") {
          if (CHART.chartObject.legend) {
            CHART.chartObject.legend.symbolHeight = 1;
            CHART.chartObject.legend.symbolWidth = 1;
          }
        } else {
          setTimeout(() => {
            if (CHART.chartObject.legend) {
              if (CHART.chartObject.legend) {
                delete CHART.chartObject.legend.symbolHeight;
                delete CHART.chartObject.legend.symbolWidth;
              }
            }
          }, 0);
        }
      }
      if (CHART.colorType) {
        this.canvasForm.get("colorType")!.setValue(CHART.colorType);
        if (CHART.chartType == "Table" || CHART.chartType == "List") {
          this.canvasForm.get("colorType")!.setValue("dynamic");
        }
      } else {
        if (CHART.chartType == "Table" || CHART.chartType == "List") {
          this.canvasForm.get("colorType")!.setValue("dynamic");
        } else {
          this.canvasForm.get("colorType")!.setValue("");
        }
      }

      if (CHART.chartColors) this.manualChartColors = CHART.chartColors.data;

      if (CHART.manualChartColors)
        this.manualChartColors = CHART.manualChartColors.data;
      this.canvasForm
        .get("manualChartColors")!
        .setValue(this.manualChartColors);

      if (CHART.dynamicChartColors && CHART.dynamicChartColors.data) {
        this.dynamicChartColors = CHART.dynamicChartColors.data;
      } else {
        if (CHART.dynamicChartColors)
          this.dynamicChartColors = CHART.dynamicChartColors;
      }

      this.canvasForm
        .get("dynamicChartColors")!
        .setValue(this.dynamicChartColors);

      // ALIAS data
      this.dataPointAliases = CHART.dataPointAliases.data;
      this.canvasForm.get("dataPointAliases")!.setValue(this.dataPointAliases);

      this.dataFields.forEach((field: any) => {
        let foundAlias = this.dataPointAliases.filter(function (alias: any) {
          return alias.id == field.id;
        });

        if (foundAlias[0]) {
          if (field.name == foundAlias[0].value) {
            field.alias = null;
          } else {
            field.alias = foundAlias[0].value;
          }
        }
      });

      let returnedVisibleDataFields = [];

      if (CHART.visibleDataPoints) {
        returnedVisibleDataFields = CHART.visibleDataPoints.data;

        const visibledatapoints: any[] = [];
        let data: any;
        returnedVisibleDataFields.forEach((field: any) => {
          data = {
            dataPointId: field.id,
            breakDownDataPointId: null,
          };
          visibledatapoints.push(data);
        });
        this.visibleDataPoints = visibledatapoints;
        this.canvasForm.get("visibleDataPointIds")!.setValue(visibledatapoints);
      } else {
        this.canvasForm.get("visibleDataPointIds")!.setValue([]);
      }

      let series = [];

      if (CHART.appliedSeries) {
        series = CHART.appliedSeries.data;

        const appliedSeries: any[] = [];
        let data: any;
        appliedSeries.forEach((field: any) => {
          data = {
            dataPointId: field.id,
            breakDownDataPointId: null,
          };
          series.push(data);
        });
        this.appliedSeries = series;
        this.canvasForm.get("appliedSeries")!.setValue(series);
      } else {
        this.canvasForm.get("appliedSeries")!.setValue([]);
      }

      if (CHART.workflows) {
        this.workflows = CHART.workflows;
      }
      // POPULATE CHART DRILLDOWN FIELDS
      if (CHART.referenceLink) {
        this.canvasForm
          .get("drilldownEnabled")!
          .setValue(CHART.referenceLink.data.isActive);
        this.canvasForm
          .get("drilldownLinkType")!
          .setValue(CHART.referenceLink.data.type);
        this.canvasForm
          .get("drilldownLinkId")!
          .setValue(CHART.referenceLink.data.id);
      } else {
        this.canvasForm.get("drilldownEnabled")!.setValue(null);
        this.canvasForm.get("drilldownLinkType")!.setValue(null);
        this.canvasForm.get("drilldownLinkId")!.setValue(null);
      }

      // POPULATE CHART FILTER FIELDS
      this.filterFields = (CHART.modifications?.data?.filters?.data || []).filter(
        (filter: any) => filter?.dataPoint?.data && Object.keys(filter.dataPoint.data).length > 0
      );
      const aggregateData = this.commonService.generateFilters(
        this.filterFields
      );
      this.canvasForm.get("filterdata")!.setValue(aggregateData);

      // POPULATE CHART SORT FIELDS
      this.sortFields = (CHART.modifications?.data?.sorts?.data || []).filter(
        (sort: any) => sort?.dataPoint?.data && Object.keys(sort.dataPoint.data).length > 0
      );
      const sortAggregateData = this.commonService.generateSorts(
        null,
        null,
        this.sortFields
      );
      this.canvasForm.get("sortdata")!.setValue(sortAggregateData);

      // POPULATE CHART GROUP FIELDS
      this.groupFields = CHART.modifications.data.groups.data;
      const groupAggregateData = this.commonService.generateGroups(
        null,
        null,
        null,
        this.groupFields
      );
      this.canvasForm.get("groupdata")!.setValue(groupAggregateData);

      this._getaDatPointConfig();

      // POPULATE CHART FORMAT FIELDS
      this.formatdata = CHART.modifications.data.formatters.data;
      const formatAggregateData = this.commonService.generateFormatters(
        this.formatdata
      );
      this.canvasForm.get("formatdata")!.setValue(formatAggregateData);
      this.canAddModifiers = true;
    } else {
      this.dataFields = [];
      this.canvasForm.get("dataPointIds")!.setValue([]);

      this.filterFields = [];
      this.canvasForm.get("filterdata")!.setValue([]);

      this.sortFields = [];
      this.canvasForm.get("sortdata")!.setValue([]);

      this.groupFields = [];
      this.canvasForm.get("groupdata")!.setValue([]);

      this.quantifierFields = [];
      this.canvasForm.get("quantifierdata")!.setValue([]);

      this.formatdata = [];
      this.canvasForm.get("formatdata")!.setValue([]);
      this.canAddModifiers = false;
    }
    setTimeout(() => {
      if (dirty) {
        this.isDirty = true;
      } else {
        this.isDirty = false;
      }
    }, 100);
  }

  _getaDatPointConfig() {
    const defaultValue =
      this.canvasOptions.quantifierOptions.data[0].default.data.value;
    let quantifierValue: number;
    if (
      this.dataFields &&
      this.dataFields.length > 0 &&
      this.dataFields[0].quantifierValues
    ) {
      quantifierValue = this.dataFields[0].quantifierValues[0].value;
    } else {
      quantifierValue = defaultValue;
    }
    if (this.dataFields && this.dataFields.length > 0) {
      const quantifiers = this.commonService.generateQuantifiers(
        this.dataFields,
        this.canvasForm.get("calculationId")!.value,
        quantifierValue
      );
      this.canvasForm.get("calculationMethod")!.setValue(quantifierValue);
      this.canvasForm.get("quantifierdata")!.setValue(quantifiers);
    }
  }

  _addQuantifierValues(chart: any) {
    let dataFields = chart.dataPoints.data;
    if (chart.modifications.data.quantifiers) {
      const quantifierFields = chart.modifications.data.quantifiers.data;
      dataFields.forEach((field: any, index: any) => {
        if (quantifierFields[index]) {
          const quantifierValues = quantifierFields[index].fields.data;
          field.quantifierValues = quantifierValues;
        }
      });
    }
    return dataFields;
  }

  _openSnackBar(message: string, success: boolean) {
    let successClass = "canvas-snackbar";
    if (!success) {
      successClass = "canvas-snackbar-error";
    }
    this._snackBar.open(message, "", {
      duration: 3000,
      panelClass: [successClass],
    });
  }

  _intializeListeners() {
    this.listener = this.canvasService.listen().subscribe(() => {
      this.saveCanvas(false, null);
    });

    this.saveAndExportListener = this.canvasService
      .listenForSaveAndExport(null)
      .subscribe((data) => {
        this.saveCanvas(true, data);
      });

    this.exportListener = this.canvasService.listenForExport().subscribe(() => {
      this.openDownloadDialog();
    });

    this.detailListener = this.canvasService.listenForDetail().subscribe(() => {
      this.openDetailDialog();
    });

    this.groupListener = this.canvasService.listenForGroups().subscribe(() => {
      this.openGroupDialog(false);
    });
    this.viewGroupListener = this.canvasService
      .listenForViewGroups()
      .subscribe(() => {
        this.openGroupDialog(true);
      });

    this.deleteListener = this.canvasService.listenForDelete().subscribe(() => {
      this.openDeleteDialog();
    });
    this.duplicateListener = this.canvasService
      .listenForDuplicate()
      .subscribe(() => {
        this.duplicateCanvas();
      });

    this.viewListener = this.canvasService.listenForView().subscribe(() => {
      this.openPreviewDialog();
    });
    this.editListener = this.canvasService.listenForEdit().subscribe(() => {
      this.openEditDialog();
    });
    this.exportToDashboardListener = this.canvasService
      .listenForExportToDashboard()
      .subscribe(() => {
        this.openExportToDashboardDialog();
      });
    this.editAsReportListener = this.canvasService
      .listenForEditAsReport()
      .subscribe(() => {
        this.openEditAsReportDialog();
      });
    this.editAsLayoutListener = this.canvasService
      .listenForEditAsLayout()
      .subscribe(() => {
        this.openEditAsLayoutDialog();
      });
    this.dirtyListener = this.canvasService.listenForDirty().subscribe(() => {
      this.isDirty = true;
    });

    this.populateListener = this.canvasService
      .listenForPopulate()
      .subscribe((data: any) => {
        this.chartDataChangedHandler(data);
      });
    this.disableListener = this.canvasService
      .listenForDisable()
      .subscribe((data: any) => {
        this.disableEdit = data;
      });
  }

  initForm() {
    this.canvasForm = this.fb.group({
      id: new FormControl(0),
      title: new FormControl("", [Validators.required]),
      module_id: new FormControl("", [Validators.required]),
      description: new FormControl("", [Validators.required]),
      itemId: new FormControl(0),
      chartTitle: new FormControl(""),
      chartType: new FormControl(""),
      dataPointIds: new FormControl([]),
      dataPointAliases: new FormControl([]),
      visibleDataPointIds: new FormControl([]),
      appliedSeries: new FormControl([]),
      collection: new FormControl([]),
      filterdata: new FormControl([]),
      sortdata: new FormControl([]),
      groupdata: new FormControl([]),
      isDateGroupRange: new FormControl(false),
      groupDateRange: new FormControl(""),
      quantifierdata: new FormControl([]),
      formatdata: new FormControl([]),
      colorType: new FormControl(""),
      manualChartColors: new FormControl([]),
      dynamicChartColors: new FormControl([]),
      calculationMethod: new FormControl([]),
      calculationId: new FormControl(0),
      dataSetListing: new FormControl([]),
      drilldownEnabled: new FormControl(false),
      drilldownLinkType: new FormControl(0),
      drilldownLinkId: new FormControl(0),
      dataLimit: new FormControl(0, [Validators.min(1)]),
      departmentScope: new FormControl(false),
      employeeScope: new FormControl(false),
      customLinks: new FormControl([]),
      filterLogicMapping: new FormControl(),
      securityGroups: new FormControl([]),
    });
  }

  addBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.add("builder");
  }

  ngOnChanges(): void {
    this.cdRef.markForCheck();
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
    const data: Data = this.route.snapshot.data;

    if (data.canvasType) {
      this.canvasType = data.canvasType;
    }

    this.addBodyClass();
    this.getUserCategories();
    if (data.isPreview) {
      this.isPreview = true;
      this.route.paramMap.subscribe((params: any) => {
        this.parameterValue = params.get("id");
        this.id = parseInt(this.parameterValue);
      });
    }
    if (data.page) {
      this.page = data.page;
    }
    if (data.canvasLayout) {
      this.canvasLayout = data.canvasLayout;
    }
    if (data.editable) {
      this.editable = data.editable;
    }
    if (data.canvasMode) {
      this.canvasMode = data.canvasMode;
    }
    this.initForm();
    if (data.hasEdit == false) {
      this.hasEdit = false;
      this.data = this.chartData;
      this.route.paramMap.subscribe((params: any) => {
        this.parameterValue = params.get("id");
        this.id = parseInt(this.parameterValue);
        if (this.parameterValue) {
          this.getCanvas(this.id);
        }
      });
    } else {
      if (this.isPreview) {
        this.getCanvas(this.id);
      } else {
        this.data = this.chartData;
        this.route.paramMap.subscribe((params: any) => {
          this.parameterValue = params.get("id");
          this.id = parseInt(this.parameterValue);
          if (this.parameterValue) {
            this.getCanvas(this.id);
          }
        });
      }
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        //console.log(event.url);
        this.routerChangeMethod();
      }
    });
  }
  
  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  routerChangeMethod() {
    const data: Data = this.route.snapshot.data;
    if (data.canvasMode) {
      this.canvasMode = data.canvasMode;
    }
  }

  ngOnDestroy() {
    this.listener.unsubscribe();
    this.exportListener.unsubscribe();
    this.viewListener.unsubscribe();
    this.detailListener.unsubscribe();
    this.deleteListener.unsubscribe();
    this.duplicateListener.unsubscribe();
    this.populateListener.unsubscribe();
    this.editListener.unsubscribe();
    this.dirtyListener.unsubscribe();
    this.saveAndExportListener.unsubscribe();
    this.exportToDashboardListener.unsubscribe();
    this.editAsReportListener.unsubscribe();
    this.groupListener.unsubscribe();
    this.viewGroupListener.unsubscribe();
    this.disableListener.unsubscribe();
    this.progressiveLoadSub?.unsubscribe();
    this.PostCall();
  }

  canDeactivate() {
    return this.isDirty;
  }
}
